import { render, staticRenderFns } from "./DetallePedido.vue?vue&type=template&id=7423cd16&scoped=true&"
import script from "./DetallePedido.vue?vue&type=script&lang=js&"
export * from "./DetallePedido.vue?vue&type=script&lang=js&"
import style0 from "./DetallePedido.vue?vue&type=style&index=0&id=7423cd16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7423cd16",
  null
  
)

export default component.exports